import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { UserItemProps } from "apis";
import { PaginationProps } from "utils/types/API";

export interface UserState {
    loading: boolean;
    list: {
        data: UserItemProps[];
        options: UserItemProps[];
        pagination?: PaginationProps;
    };
    item: {
        data?: UserItemProps;
    };
}

const initialState: UserState = {
    loading: false,
    list: {
        data: [],
        options: []
    },
    item: {
    }
};

interface IndexProps {
    data: UserItemProps[];
    pagination?: PaginationProps;
}
interface ItemProps {
    data?: UserItemProps;
}
export const userSlice = createSlice({
    name: "user",
    initialState,
    reducers: {
        loading: (state) => {
            state.loading = true;
        },
        endLoading: (state) => {
            state.loading = false;
        },
        index: (state, action: PayloadAction<IndexProps>) => {
            state.loading = false;
            state.list.data = action.payload.data;
            state.list.pagination = action.payload.pagination;
        },
        options: (state, action: PayloadAction<IndexProps>) => {
            state.loading = false;
            state.list.options = action.payload.data;
        },
        find: (state, action: PayloadAction<ItemProps>) => {
            state.loading = false;
            state.item.data = action.payload.data;
        },
        create: (state, action: PayloadAction<ItemProps>) => {
            state.loading = false;
            state.item.data = action.payload.data;
        },
        update: (state, action: PayloadAction<ItemProps>) => {
            state.loading = false;
            state.item.data = action.payload.data;
            state.list.data = state.list.data.map(item => item.id === action.payload.data?.id ? action.payload.data : item);
        },
    },
});

export const { loading, endLoading, index, options, find, create, update } = userSlice.actions;
export default userSlice.reducer;
